module.exports = __webpack_public_path__ + "static/media/sushi-go.8866df00.png";